import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import { StarRating } from './StarRating';

interface AverageRatingProps {
  averageRating: number;
  reviews: number;
}

export const AverageRating = forwardRef<HTMLDivElement, AverageRatingProps>(
  ({ averageRating, reviews }, ref) => {
    const scrollToReviews = () => {
      // Check if ref exists and has current property
      if (!ref || !('current' in ref) || !ref.current) {
        return;
      }
      // if the state of the references section is closed, then programmatically open it. Then scroll.
      const triggerElement = ref.current.querySelector(`[id="Reviews"]`);

      if (triggerElement && triggerElement instanceof HTMLElement) {
        triggerElement.click();
      }

      // Scroll to the referenced element after a brief delay to account for having to open it if closed.
      // Delay is not noticable to user
      setTimeout(() => {
        const targetElement = document.getElementById('Reviews');
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    };

    return (
      <>
        {averageRating > 0 ? (
          <p className="flex gap-1 py-2 text-sm">
            <StarRating rating={averageRating} />
            {averageRating} from {reviews}{' '}
            <button
              type="button"
              className={twMerge([
                'border-none bg-inherit p-0 text-start',
                'clickable',
              ])}
              onClick={scrollToReviews}
            >
              reviews
            </button>
          </p>
        ) : null}
      </>
    );
  }
);

AverageRating.displayName = 'AverageRating';
